import _ from 'lodash'
import React, { Component } from 'react'

import getPerformance from '../api/get-performance'
import getSeatTickets from '../api/get-seat-tickets'
import setSeatPrice from '../api/set-seat-price'
import setGaPrice from '../api/set-ga-price'
import setGaAmount from '../api/set-ga-amount'
import clearPrice from '../api/clear-price'
import clearGaPrice from '../api/clear-ga-price'
import clearAllPrices from '../api/clear-all-prices'
import createTickets from '../api/create-tickets'
import deleteTickets from '../api/delete-tickets'
import syncSeats from '../api/sync-seats'
import Loader from './utils/Loader'
import { ErrorMessage } from './utils/ErrorMessages'

import NotFoundPage from '../pages/NotFoundPage'
import SeatMapEditor from  './seats-editor/SeatMapEditor'


class SeatsEditor extends Component {
    constructor (props) {
        super (props)
        this.state = {
            performance: null,
            tickets: [],
            notFound: false
        }
    }

    componentDidMount () {
        this.loadPerformance(this.props.performanceId)
        this.loadTickets(this.props.performanceId)
    }

    render () {
        if (this.state.notFound) {
            return <NotFoundPage />
        }
        if (!this.state.performance) {
            return <Loader /> 
        }

        return <EditingForm performance={this.state.performance} tickets={this.state.tickets}/>
    }

    loadPerformance = (performanceId) => {
        getPerformance(performanceId)
            .then(response => {
                if (!response.ok) {
                    throw response
                }
                return response.json()
            }).then(result => {
                this.setState({
                    performance: result
                });
            }).catch(() => {
                this.setNotFound()
            })
    }

    loadTickets = (performanceId) => {
        getSeatTickets(performanceId)
            .then(response => {
                if (!response.ok) {
                    throw response
                }
                return response.json()
            }).then(result => {
                this.setState({
                    tickets: result
                });
            }).catch(() => {
                this.setNotFound()
            })
    }

    setNotFound = () => {
        this.setState({
            notFound: true
        })
    }
}

class EditingForm extends Component {
    constructor (props) {
        super(props)
        this.eventId = props.performance.event.uuid
        this.performanceId = props.performance.uuid

        this.state = {
            errors: {},
            seats: [],
            gaSector: null,
        }
    }

    render () {
        return (
            <>
                <SeatMapEditor
                    smEventId={this.props.performance.seatmap_event_id}
                    tickets={this.props.tickets}
                    seats={this.state.seats}
                    sector={this.state.gaSector}
                    onChange={this.handleSeatsChange}
                    onEditGASector={this.handleGASectorEdit}/>

                {this.state.gaSector ?
                    <>
                        <div className='row tickets-editor-row'>
                            <button className='u-full-width button-primary' onClick={() => this.handleGASectorEdit(null)}>
                                Назад к редактированию мест
                            </button>
                        </div>
                        <GAActions sector={this.state.gaSector} performance={this.props.performance}/>
                    </> :
                    <SeatActions seats={this.state.seats} performance={this.props.performance}/>
                }

                <CommonActons performance={this.props.performance}/>

                <ErrorMessage
                    for='global'
                    errors={this.state.errors} />
            </>
        )
    }

    resetErrors = () => this.setState({errors: {}})

    handleSeatsChange = (seats) => {
        this.setState({seats: seats})
    }

    handleGASectorEdit = (sector) => {
        this.setState({gaSector: sector})
    }
}

class SeatActions extends Component {
    constructor (props) {
        super(props)

        this.state = {
            price: 0
        }
    }

    render() {
        return (
            <div className='tickets-editor-block'>
                <div className='row tickets-editor-row'>
                    <div className='three columns'>
                        <input className="u-full-width" type='number' min='0' value={this.state.price} onChange={this.handlePriceChange}></input>
                    </div>
                    <div className='nine columns'>
                        <button className='u-full-width button-primary' disabled={this.isSetPriceDisabled()} onClick={this.setPrice}>Назначить цену билетам</button>
                    </div>
                </div>

                <div className='row tickets-editor-row'>
                    <div className='twelve columns'>
                        <button className='u-full-width button-primary' disabled={this.isClearPriceDisabled()} onClick={this.clearPrices}>Очистить цены для выбранных мест</button>
                    </div>
                </div>

                <div className='row tickets-editor-row'>
                    <div className='six columns'>
                        <button className='u-full-width button-primary' disabled={this.isCreateTicketsDisabled()} onClick={this.createTickets}>Создать билеты для выбранных мест</button>
                    </div>
                    <div className='six columns'>
                        <button className='u-full-width button-primary' disabled={this.isDeleteTicketsDisabled()} onClick={this.deleteTickets}>Удалить билеты у выбранных мест</button>
                    </div>
                </div>
            </div>
        )
    }

    handlePriceChange = (event) => {
        if (event.target.value === "") {
            this.setState({price: ""})
        } else {
            this.setState({price: Number(event.target.value)})
        }
    }

    isSetPriceDisabled = () => {
        return this.props.seats.length === 0 || !this.state.price
    }

    isClearPriceDisabled = () => {
        return this.props.seats.length === 0
    }

    isCreateTicketsDisabled = () => {
        return this.props.seats.length === 0
    }

    isDeleteTicketsDisabled = () => {
        return this.props.seats.length === 0
    }

    setPrice = () => {
        if (this.props.seats.length === 0) {
            return
        }
        setSeatPrice(
            this.props.performance.uuid, this.getChosenSeatsKeys(), this.state.price
        ).then((result) => window.location.reload())
    }

    clearPrices = () => {
        if (this.props.seats.length === 0) {
            return
        }
        clearPrice(
            this.props.performance.uuid, this.getChosenSeatsKeys()
        ).then((result) => window.location.reload())
    }

    createTickets = () => {
        if (this.props.seats.length === 0) {
            return
        }
        createTickets(
            this.props.performance.uuid, this.getChosenSeatsKeys()
        ).then((result) => window.location.reload())
    }

    deleteTickets = () => {
        if (this.props.seats.length === 0) {
            return
        }
        deleteTickets(
            this.props.performance.uuid, this.getChosenSeatsKeys()
        ).then((result) => window.location.reload())
    }

    getChosenSeatsKeys = () => {
        return _.map(this.props.seats, (seat) => {return {key: seat.key}})
    }
}

class GAActions extends Component {
    constructor (props) {
        super(props)

        this.state = {
            price: props.sector.price,
            ticketsAmount: 0
        }
    }

    render() {
        return (
            <div className='tickets-editor-block'>
                <div className='row tickets-editor-row'>
                    <div className='three columns'>
                        <input className="u-full-width" type='number' min='0' value={this.state.price} onChange={this.handlePriceChange}></input>
                    </div>
                    <div className='nine columns'>
                        <button className='u-full-width button-primary' disabled={this.isSetPriceDisabled()} onClick={this.setPrice}>Назначить цену билетам</button>
                    </div>
                </div>

                <div className='row tickets-editor-row'>
                    <div className='three columns'>
                        <input className="u-full-width" type='number' min='0' value={this.state.ticketsAmount} onChange={this.handleTicketsAmountChange}></input>
                    </div>
                    <div className='nine columns'>
                        <button className='u-full-width button-primary' disabled={this.isSetTicketsAmountDisabled()} onClick={this.setTicketsAmount}>Установить новое количество билетов</button>
                    </div>
                </div>

                <div className='row tickets-editor-row'>
                    <div className='twelve columns'>
                        <button className='u-full-width button-primary' onClick={this.clearPrice}>Очистить цену сектора</button>
                    </div>
                </div>
            </div>
        )
    }

    isSetPriceDisabled() {
        return !this.state.price
    }

    handlePriceChange = (event) => {
        if (event.target.value === "") {
            this.setState({price: ""})
        } else {
            this.setState({price: Number(event.target.value)})
        }
    }

    setPrice = () => {
        setGaPrice(
            this.props.performance.uuid, {key: this.props.sector.name}, this.state.price
        ).then((result) => window.location.reload())
    }

    isSetTicketsAmountDisabled() {
        return !this.state.ticketsAmount
    }

    handleTicketsAmountChange = (event) => {
        if (event.target.value === "") {
            this.setState({ticketsAmount: ""})
        } else {
            this.setState({ticketsAmount: Number(event.target.value)})
        }
    }

    setTicketsAmount = () => {
        const price = this.props.sector.price || 0;
        setGaAmount(
            this.props.performance.uuid, {key: this.props.sector.name}, this.state.ticketsAmount, price
        ).then((result) => window.location.reload())
    }

    clearPrice = () => {
        clearGaPrice(
            this.props.performance.uuid, [{key: this.props.sector.name}]
        ).then((result) => window.location.reload())
    }
}

class CommonActons extends Component {
    render() {
        return (
            <div className='tickets-editor-block'>
                <div className='row tickets-editor-row'>
                    <div className='twelve columns'>
                        <button className='u-full-width button-primary' onClick={this.syncSeats}>Синхронизовать места</button>
                    </div>
                </div>

                <div className='row tickets-editor-row'>
                    <div className='twelve columns'>
                        <button className='u-full-width button-primary' onClick={this.clearAllPrices}>Очистить все цены</button>
                    </div>
                </div>
            </div>
        )
    }

    clearAllPrices = () => {
        if (window.confirm("Вы уверены, что хотите очистить все цены?")) {
            clearAllPrices(
                this.props.performance.uuid, []
            ).then((result) => window.location.reload())
        }
    }

    syncSeats = () => {
        syncSeats(
            this.props.performance.uuid
        ).then((result) => window.location.reload())
    }
}

export default SeatsEditor
